import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "flex items-center mb-4" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "text-brand-600" };
const _hoisted_5 = {
    key: 2,
    class: "flex items-center mr-4"
};
const _hoisted_6 = { class: "success-message" };
const _hoisted_7 = {
    key: 0,
    class: "lg:flex"
};
const _hoisted_8 = { class: "lg:w-1/2 lg:mr-2" };
const _hoisted_9 = { class: "w-full h-48" };
const _hoisted_10 = { class: "text-slate-600" };
const _hoisted_11 = { class: "p-2 text-right" };
const _hoisted_12 = { href: "#" };
const _hoisted_13 = { class: "p-2 text-right" };
const _hoisted_14 = { class: "p-2 text-right" };
const _hoisted_15 = { class: "p-2 text-right" };
const _hoisted_16 = { class: "p-2 text-right" };
const _hoisted_17 = ["href"];
const _hoisted_18 = {
    class: "w-full",
    role: "presentation"
};
const _hoisted_19 = { class: "p-2 text-right text-slate-600 font-medium text-xl" };
const _hoisted_20 = { class: "lg:w-1/2 lg:ml-2" };
const _hoisted_21 = { class: "w-full h-48" };
const _hoisted_22 = { class: "text-slate-600" };
const _hoisted_23 = { class: "p-2 text-right" };
const _hoisted_24 = { class: "p-2 text-right" };
const _hoisted_25 = { class: "p-2 text-right" };
const _hoisted_26 = { class: "p-2 text-right" };
const _hoisted_27 = { class: "p-2 text-right" };
const _hoisted_28 = {
    class: "w-full",
    role: "presentation"
};
const _hoisted_29 = { class: "p-2 text-right text-slate-600 font-medium text-xl" };
const _hoisted_30 = { class: "flex items-center mb-4" };
const _hoisted_31 = {
    key: 0,
    class: "flex"
};
const _hoisted_32 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_33 = {
    class: "text-lg leading-6 font-medium text-slate-900",
    id: "process-order"
};
const _hoisted_34 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_35 = {
    class: "text-lg leading-6 font-medium text-slate-900",
    id: "check-status"
};
const _hoisted_36 = {
    key: 2,
    class: "hidden lg:flex items-center mr-2"
};
const _hoisted_37 = ["value"];
const _hoisted_38 = ["href"];
const _hoisted_39 = {
    key: 2,
    id: "campaign-code-orders",
    class: "admin-table"
};
const _hoisted_40 = { class: "colored-row" };
const _hoisted_41 = { class: "flex items-center" };
const _hoisted_42 = ["src"];
const _hoisted_43 = { class: "block text-slate-800 font-medium" };
const _hoisted_44 = { class: "text-slate-500 text-sm" };
const _hoisted_45 = { class: "text-center" };
const _hoisted_46 = { key: 0 };
const _hoisted_47 = { key: 1 };
const _hoisted_48 = { class: "text-right" };
const _hoisted_49 = { class: "block font-semibold" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Loading = _resolveComponent("Loading");
    const _component_OrderEmailEditModal = _resolveComponent("OrderEmailEditModal");
    const _component_ConfirmationModal = _resolveComponent("ConfirmationModal");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            (!_ctx.order.isLoaded())
                ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Manage Order"))
                : (_openBlock(), _createElementBlock("h1", _hoisted_3, [
                    _cache[7] || (_cache[7] = _createTextVNode("Order ", -1)),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.order.data.reference), 1)
                ])),
            (_ctx.order.getSuccessMessage())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.order.getSuccessMessage()), 1)
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.order.resendNotification())),
                    type: "button",
                    class: "btn mr-2"
                }, "Resend Notification"),
                _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.order.navigation.goBack && _ctx.order.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back")
            ])
        ]),
        (_ctx.order.isLoaded())
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("section", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                        _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-600",
                                    colspan: "2"
                                }, "Details")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_10, [
                            _createElementVNode("tr", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Serial", -1)),
                                _createElementVNode("td", _hoisted_11, [
                                    _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.order.data.serial), 1)
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Status", -1)),
                                _createElementVNode("td", _hoisted_13, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["status-box with-ping", {
                                                'status-open': _ctx.order.data.status === 'open',
                                                'status-processing': _ctx.order.data.status === 'processing',
                                                'status-complete': _ctx.order.data.status === 'complete',
                                                'status-cancelled': _ctx.order.data.status === 'cancelled',
                                            }])
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.order.data.status), 1)
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Campaign", -1)),
                                _createElementVNode("td", _hoisted_14, [
                                    _createVNode(_component_router_link, {
                                        to: { name: 'admin.campaign.manage', params: { account: _ctx.order.data.account, slug: _ctx.order.data.campaign } }
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.order.data.campaign_name), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["to"])
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Order Date", -1)),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.f.formatDate(_ctx.order.data.created_at)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[14] || (_cache[14] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Name", -1)),
                                _createElementVNode("td", _hoisted_16, [
                                    _createTextVNode(_toDisplayString(_ctx.order.data.name) + " <", 1),
                                    _createElementVNode("a", {
                                        href: `mailto:${_ctx.order.data.email}`,
                                        target: "_blank"
                                    }, _toDisplayString(_ctx.order.data.email), 9, _hoisted_17),
                                    _cache[13] || (_cache[13] = _createTextVNode("> ", -1)),
                                    (_ctx.permissions.isAdmin())
                                        ? (_openBlock(), _createElementBlock("svg", {
                                            key: 0,
                                            onClick: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.openOrderEmailEditModal && _ctx.openOrderEmailEditModal(...args))),
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-4 w-4 text-gray-500 inline cursor-pointer",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                        }, [...(_cache[12] || (_cache[12] = [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M15.232 5.232l3.536 3.536m-2.036-4.036a2.5 2.5 0 113.536 3.536L7.5 20.5H4v-3.5L16.732 5.732z"
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "my-2 border-slate-400" }, null, -1)),
                    _createElementVNode("table", _hoisted_18, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "p-2 text-left text-slate-600 font-medium" }, "Payment", -1)),
                                _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, _ctx.order.data.prepaid / 100)), 1)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_20, [
                    _createElementVNode("table", _hoisted_21, [
                        _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-600",
                                    colspan: "2"
                                }, "Totals")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_22, [
                            _createElementVNode("tr", null, [
                                _cache[18] || (_cache[18] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Gross Total", -1)),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, _ctx.order.data.product_gross_value / 100)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Tax", -1)),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, _ctx.order.data.order_tax / 100)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[20] || (_cache[20] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Discount", -1)),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, _ctx.order.data.discount / 100)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Transaction Fee", -1)),
                                _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, _ctx.order.data.transaction_fee / 100)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[22] || (_cache[22] = _createElementVNode("td", { class: "p-2 text-left text-sm" }, "Transaction Fee Tax", -1)),
                                _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, _ctx.order.data.transaction_fee_tax / 100)), 1)
                            ])
                        ])
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("hr", { class: "my-2 border-slate-400" }, null, -1)),
                    _createElementVNode("table", _hoisted_28, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _cache[24] || (_cache[24] = _createElementVNode("td", { class: "p-2 text-left text-slate-600 font-medium" }, "Total", -1)),
                                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, _ctx.order.data.order_total / 100)), 1)
                            ])
                        ])
                    ])
                ])
            ]))
            : (_openBlock(), _createBlock(_component_Loading, {
                key: 1,
                message: "Loading Order"
            })),
        _createVNode(_component_OrderEmailEditModal, {
            show: _ctx.isOrderEmailEditModalOpen,
            order: _ctx.order,
            onClose: _ctx.closeOrderEmailEditModal,
            onEmailUpdated: _ctx.handleEmailUpdated
        }, null, 8, ["show", "order", "onClose", "onEmailUpdated"]),
        _createElementVNode("div", _hoisted_30, [
            _cache[31] || (_cache[31] = _createElementVNode("h2", { class: "flex-1 font-medium mb-4 text-xl" }, "Order Items", -1)),
            (_ctx.order.isLoaded())
                ? (_openBlock(), _createElementBlock("nav", _hoisted_31, [
                    (_ctx.order.data.status === 'open' && _ctx.permissions.isAdmin())
                        ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
                            key: 0,
                            id: "process-order",
                            buttonClass: "btn mr-2",
                            buttonText: "Process Order",
                            onConfirmAction: _cache[3] || (_cache[3] = ($event) => (_ctx.order.processOrder()))
                        }, {
                            default: _withCtx(() => [
                                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                    _createElementVNode("svg", {
                                        class: "h-6 w-6 text-brand-600",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        role: "img",
                                        focusable: "false",
                                        "aria-label": "Warning"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                        })
                                    ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("h3", _hoisted_33, "Process Order " + _toDisplayString(_ctx.order.data.reference), 1),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mt-2" }, [
                                        _createElementVNode("p", { class: "text-sm text-slate-500" }, "Are you sure you would like to process this order?")
                                    ], -1))
                                ])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.order.data.status === 'processing' && _ctx.permissions.isAdmin())
                        ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
                            key: 1,
                            id: "check-status",
                            buttonClass: "btn mr-2",
                            buttonText: "Check Order Status",
                            onConfirmAction: _cache[4] || (_cache[4] = ($event) => (_ctx.order.checkStatus()))
                        }, {
                            default: _withCtx(() => [
                                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                    _createElementVNode("svg", {
                                        class: "h-6 w-6 text-brand-600",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        role: "img",
                                        focusable: "false",
                                        "aria-label": "Warning"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                        })
                                    ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("h3", _hoisted_35, "Check Order Status " + _toDisplayString(_ctx.order.data.reference), 1),
                                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mt-2" }, [
                                        _createElementVNode("p", { class: "text-sm text-slate-500" }, "Are you sure you would check the status of this order?")
                                    ], -1))
                                ])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.order.data.status === 'complete')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _cache[30] || (_cache[30] = _createElementVNode("label", {
                                for: "account_id",
                                class: "form-label-style w-48 text-right mr-2"
                            }, "Export Format", -1)),
                            _withDirectives(_createElementVNode("select", {
                                name: "account_id",
                                id: "account_id",
                                class: "form-input-style",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.order.export_format) = $event)),
                                onChange: _cache[6] || (_cache[6] = ($event) => (_ctx.order.updateDownloadFormat())),
                                autocomplete: "off"
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.exportFormats, (method) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        value: method.value
                                    }, _toDisplayString(method.name), 9, _hoisted_37));
                                }), 256))
                            ], 544), [
                                [_vModelSelect, _ctx.order.export_format]
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.order.data.status === 'complete')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 3,
                            href: `/download/order/${_ctx.order.data.slug}?format=${_ctx.order.export_format}`,
                            target: "_blank",
                            class: "dark mr-2"
                        }, " Download Codes ", 8, _hoisted_38))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true)
        ]),
        (_ctx.order.isLoaded())
            ? (_openBlock(), _createElementBlock("section", _hoisted_39, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Order ID"),
                                        _createElementVNode("th", {
                                            scope: "col",
                                            class: "text-center"
                                        }, "Product Serial"),
                                        _createElementVNode("th", {
                                            scope: "col",
                                            class: "text-right"
                                        }, "Product Value"),
                                        _createElementVNode("th", { scope: "col" }, " ")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.data.items, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                            _createElementVNode("td", _hoisted_41, [
                                                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "hidden lg:flex font-semibold mr-2" }, "   ", -1)),
                                                _createElementVNode("img", {
                                                    src: item.image,
                                                    alt: "No Image",
                                                    class: "w-12 lg:w-20 bg-contain my-2"
                                                }, null, 8, _hoisted_42)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", _hoisted_43, _toDisplayString(item.product_name), 1),
                                                _createElementVNode("span", _hoisted_44, _toDisplayString(item.uuid), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_45, [
                                                (item.serial)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(item.serial), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_47, "-"))
                                            ]),
                                            _createElementVNode("td", _hoisted_48, [
                                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.f.formatCurrency(_ctx.order.data.order_currency, item.value / 100)), 1)
                                            ]),
                                            _cache[33] || (_cache[33] = _createElementVNode("td", { class: "font-medium" }, "   ", -1))
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
